<template>
  <Modal v-bind="$attrs" @cancel="$emit('update:visible', false)" @confirm="onConfirm">
    <div class="shot-list">
      <ShotItem v-model="materialCheckedId" v-for="video in list" :key="video.id" :video="video"></ShotItem>
    </div>
  </Modal>
</template>

<script setup>
import { ref, watch } from 'vue'
import ShotItem from './shot-video-item.vue'
import { Message } from 'view-design'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
// eslint-disable-next-line
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  },
  value: {
    type: [Number, String]
  }
})
// eslint-disable-next-line
const emit = defineEmits(['change'])
const materialCheckedId = ref(props.value)

watch(
  () => props.value,
  (newVal) => {
    materialCheckedId.value = newVal
  }
)

function onConfirm() {
  if (!materialCheckedId.value) return Message.warning('请至少选择一个素材')
  emit('change', materialCheckedId.value)
}
</script>

<style scoped lang="scss">
@import '~common/styles/element-ui/variables.scss';
.shot-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
</style>
